// extracted by mini-css-extract-plugin
export default {"root":"YearMonthForm_root__LsAmQ","placeHolderShimmer":"YearMonthForm_placeHolderShimmer__fDLRU"};